<div class="my-2 flex flex-col rounded" xmlns="http://www.w3.org/1999/html">

  <div class="mb-4 flex w-full items-start justify-between xs:flex-col">

    <div class="w-4/12 xs:mb-4 xs:w-full sm:w-8/12 md:w-8/12 lg:w-6/12" *ngIf="showSearch">
      <div class="flex w-full items-start justify-start gap-4">
        <div class="input-wrapper flex items-center gap-2 border-2 border-gray-400">
          <span class="material-icons text-primario-700">search</span>
          <input
            [placeholder]="'tabela.pesquisar' | message"
            type="text"
            class="input-base"
            [ngModel]="query"
            (ngModelChange)="onSearchInput($event)"
            id="pesquisar"
            name="pesquisar"
            autocomplete="off"
          />
          <button
            type="button"
            [title]="'tabela.limpar' | message"
            *ngIf="query"
            (click)="handleClearQuery()"
            class="flex items-center rounded bg-neutro-100 p-1 text-xs transition-all duration-150 hover:bg-gray-200"
          >
            <span class="material-icons text-black">close</span>
          </button>
        </div>
      </div>
    </div>

    <div class="flex gap-4 ml-auto">
      <button
        [disabled]="!(hasBadgeImport === false || badgeImport > 0)"
        *ngIf="hasImport"
        (click)="emitImport()"
        type="button"
        [title]="hasBadgeImport === false || badgeImport > 0
          ? titleButtonImport ? titleButtonImport : ('tabela.btn.importar' | message)
          : ('tabela.btn.importar.indisponivel' | message)"
        class="base-btn bg-primario-700 text-branco disabled:bg-gray-500 hover:opacity-90"
        color="primary"
        [matBadge]="badgeImport"
        matBadgePosition="before"
        matBadgeColor="accent"
      >
        <span class="material-icons">upload_file</span>
        {{ titleButtonImport ? titleButtonImport : ('tabela.btn.importar' | message) }}
      </button>

      <app-export-table
        *ngIf="hasExportFile"
        [fileName]="fileNameExport"
        [path]="pathExport"
        [params]="paramsToExportFile"
        [pathCustomized]="pathExportCustomized"
      ></app-export-table>

      <button
        *ngIf="hasRelatorio"
        (click)="handleRelatorio.emit()"
        type="button"
        [title]="'tabela.btn.relatorio' | message"
        class="base-btn bg-primario-700 text-branco hover:opacity-90"
      >
        <span class="material-icons">summarize</span>
        {{ 'tabela.btn.relatorio' | message }}
      </button>

      <button
        *ngIf="hasExport"
        [matMenuTriggerFor]="exportMenu"
        type="button"
        [title]="'tabela.btn.exportar' | message"
        class="base-btn bg-primario-700 text-branco hover:opacity-90"
      >
        <span class="material-icons">download</span>
        {{ 'tabela.btn.exportar' | message }}
      </button>

      <mat-menu #exportMenu="matMenu">
        <button mat-menu-item (click)="handleExportar('excel')">
          <span class="material-icons">table_view</span>
          {{ 'tabela.btn.exportar.excel' | message }}
        </button>
        <button mat-menu-item (click)="handleExportar('pdf')">
          <span class="material-icons">picture_as_pdf</span>
          {{ 'tabela.btn.exportar.pdf' | message }}
        </button>
      </mat-menu>

      <button
        *ngIf="hasCreate"
        (click)="emitCreate()"
        type="button"
        [title]="titleButtonCreate ? titleButtonCreate : ('tabela.btn.inserir' | message)"
        class="base-btn bg-primario-700 text-branco"
      >
        <span class="material-icons">add</span>
        {{ titleButtonCreate ? titleButtonCreate : ('tabela.btn.inserir' | message) }}
      </button>
    </div>

  </div>

  <div class="filter-chips-bar">
    <ng-container *ngIf="activeFilterChips.length > 0">
      <div class="filter-chips-list">
        <span class="filter-chip" *ngFor="let chip of activeFilterChips">
          <span class="filter-chip-text">{{ chip.label }}: <strong>{{ chip.displayValue }}</strong></span>
        </span>
      </div>
      <button type="button" class="filter-chips-clear-all" (click)="clearAllColumnFilters()">
        <span class="material-icons">filter_alt_off</span>
        {{ 'tabela.filtro.limpar' | message }}
      </button>
    </ng-container>
  </div>

  <div class="max-h-[69vh] overflow-x-auto overflow-y-auto pb-2 scrollbar-thin scrollbar-track-neutro-100 scrollbar-thumb-gray-300">
    <div *ngIf="isLoading; else showTable" class="flex items-center justify-center py-8">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>

    <ng-template #showTable>
      <table
        mat-table
        matSort
        [matSortDisabled]="isSortDisable"
        [dataSource]="data"
        [trackBy]="trackByFn"
        [matSortActive]="handleCheckSortActive()"
        [matSortDirection]="handleCheckSortDirection()"
        (matSortChange)="handleSort($event)"
        class="relative w-full"
      >
        <ng-container *ngFor="let headerOption of headerOptions; let i = index" [matColumnDef]="headerOption.attribute">
          <th mat-header-cell *matHeaderCellDef class="bg-neutro-100 th-cell">
            <div class="th-wrapper">
              <div
                [mat-sort-header]="headerOption.attribute"
                [disabled]="headerOption.sortable === false"
                arrowPosition="after"
                class="th-title"
              >
                {{ headerOption.description }}
              </div>
              <div class="th-filter" (click)="$event.stopPropagation()" *ngIf="getFilterType(headerOption) !== 'none'">
                <table-filter-input
                  [type]="getFilterInputType(headerOption)"
                  [placeholder]="headerOption.filter?.placeholder || ('tabela.filtro.filtrar' | message)"
                  [filterValue]="columnFilterValues.get(headerOption.attribute) ?? ''"
                  [options]="headerOption.filter?.options ?? []"
                  [options$]="headerOption.filter?.options$"
                  (filterChange)="onColumnFilterChange(headerOption.attribute, $event)"
                ></table-filter-input>
              </div>
            </div>
          </th>

          <ng-container *ngIf="headerOption.type">
            <td mat-cell class="text-base" *matCellDef="let element">
              <div
                [innerHTML]="
                  headerOption?.type && headerOption?.isToFormatValue === false && element[headerOption.attribute] !== null
                    ? element[headerOption.attribute]
                    : headerOption?.type === 'NUMBER' && element[headerOption.attribute] !== null && element[headerOption.attribute] !== ''
                    ? (element[headerOption.attribute] | number : headerOption?.digitsInfo ?? digitsInfoDefault : 'pt')
                    : headerOption?.type === 'DATE_TIME_MILLISECONDS' && element[headerOption.attribute]
                    ? (element[headerOption.attribute] | date : 'dd/MM/yyyy HH:mm:ss.SSS')
                    : headerOption?.type === 'DATE_TIME' && element[headerOption.attribute]
                    ? (element[headerOption.attribute] | date : 'dd/MM/yyyy HH:mm' : 'GMT-3')
                    : headerOption?.type === 'DATE' && element[headerOption.attribute]
                    ? (element[headerOption.attribute] | date : 'dd/MM/yyyy')
                    : headerOption?.type === 'TIME' && element[headerOption.attribute]
                    ? element[headerOption.attribute]
                    : '-'
                "
              ></div>
            </td>
          </ng-container>

          <ng-container *ngIf="!headerOption.type">
            <td mat-cell class="text-base" *matCellDef="let element">
              <div [innerHTML]="element[headerOption.attribute] ? element[headerOption.attribute] : '-'"></div>
            </td>
          </ng-container>
        </ng-container>

        <ng-container [matColumnDef]="'inicio'">
          <th mat-header-cell *matHeaderCellDef class="bg-neutro-100 text-lg"></th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container>

        <ng-container [matColumnDef]="'checkbox'">
          <th mat-header-cell *matHeaderCellDef class="absolute bg-neutro-100">
            <mat-checkbox
              color="primary"
              (change)="$event ? toggleAllRows() : null"
              [checked]="selectionCheckbox.hasValue() && isAllSelected()"
              [indeterminate]="selectionCheckbox.hasValue() && !isAllSelected()"
              [title]="isAllSelected() ? ('tabela.btn.selecionar.todos' | message) : ('tabela.btn.remover.todos' | message)"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleOneRow(row) : null"
              [checked]="selectionCheckbox.isSelected(row)"
              [title]="selectionCheckbox.isSelected(row) ? ('tabela.btn.selecionar' | message) : ('tabela.btn.remover' | message)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="'acoes'">
          <th mat-header-cell *matHeaderCellDef class="bg-neutro-100 th-cell">
            <div class="th-wrapper">
              <span class="th-title">{{ 'tabela.coluna.acoes' | message }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element" class="acoes-cell">
            <div class="action-btns">
              <button
                class="button-icon"
                *ngIf="hasOtherAction"
                (click)="emitOtherAction(element)"
                [title]="titleButtonOtherAction ? titleButtonOtherAction : ('tabela.btn.outro' | message)"
                type="button"
                [disabled]="element.isDisableOtherAction"
                [ngClass]="{ 'button-icon-disable': element.isDisableOtherAction }"
              >
                <span class="material-icons text-2xl">{{ iconButtonOtherAction || 'assignment_turned_in' }}</span>
              </button>

              <button
                class="button-icon validate"
                *ngIf="hasValidate"
                (click)="emitValidate(element.id)"
                [title]="titleButtonValidate ? titleButtonValidate : ('tabela.btn.validar' | message)"
                type="button"
                [disabled]="element.isDisableValidate"
                [ngClass]="{
                  'button-icon-disable': element.isDisableValidate,
                  'validate-ready': !element.isDisableValidate && element.pronto_validacao === 'Sim',
                  'validate-pending': !element.isDisableValidate && element.pronto_validacao === 'Não'
                }"
              >
                <span class="material-icons text-2xl">{{ iconButtonValidate || 'assignment_turned_in' }}</span>
              </button>

              <button
                class="button-icon view"
                *ngIf="hasDetail"
                (click)="emitDetail(element.id)"
                [title]="titleButtonDetail ? titleButtonDetail : ('tabela.btn.visualizar' | message)"
                type="button"
              >
                <span class="material-icons text-2xl">find_in_page</span>
              </button>

              <button
                class="button-icon edit"
                *ngIf="hasEdit"
                (click)="emitEdit(element.id)"
                [title]="titleButtonEdit ? titleButtonEdit : ('tabela.btn.editar' | message)"
                type="button"
                [disabled]="element.isDisableEdit"
                [ngClass]="{ 'button-icon-disable': element.isDisableEdit }"
              >
                <span class="material-icons text-2xl">edit</span>
              </button>

              <button
                class="button-icon del"
                *ngIf="hasDelete"
                (click)="emitDelete(element.id)"
                [title]="titleButtonDelete ? titleButtonDelete : ('tabela.btn.deletar' | message)"
                type="button"
                [disabled]="element.isDisableDelete"
                [ngClass]="{ 'button-icon-disable': element.isDisableDelete }"
              >
                <span class="material-icons text-2xl">delete</span>
              </button>

              <button
                class="button-icon info"
                *ngIf="
                  element.display_info_criacao === null ||
                  element.display_info_criacao ||
                  element.display_info_alteracao === null ||
                  element.display_info_alteracao ||
                  element.display_info_validacao === null ||
                  element.display_info_validacao ||
                  element.display_info_encerramento === null ||
                  element.display_info_encerramento
                "
                [matMenuTriggerFor]="matMenuInfoData"
                [title]="'tabela.btn.informacoes' | message"
                type="button"
              >
                <span class="material-icons text-xl">info</span>
              </button>

              <button
                class="button-icon hist"
                *ngIf="hasHistory"
                (click)="emitHistory(element.id)"
                [title]="'tabela.btn.historico' | message"
                type="button"
              >
                <span class="material-icons text-xl">history</span>
              </button>

              <mat-menu #matMenuInfoData="matMenu" class="p-2">
                <p *ngIf="element.display_info_criacao === null || element.display_info_criacao" class="text-sm">
                  {{ 'tabela.info.criacao' | message }} <span class="font-semibold">{{ element.display_info_criacao === null ? '-' : element.display_info_criacao }}</span>
                </p>
                <p *ngIf="element.display_info_alteracao === null || element.display_info_alteracao" class="text-sm">
                  {{ 'tabela.info.alteracao' | message }} <span class="font-semibold">{{ element.display_info_alteracao === null ? '-' : element.display_info_alteracao }}</span>
                </p>
                <p *ngIf="element.display_info_validacao === null || element.display_info_validacao" class="text-sm">
                  {{ 'tabela.info.validacao' | message }} <span class="font-semibold">{{ element.display_info_validacao === null ? '-' : element.display_info_validacao }}</span>
                </p>
                <p *ngIf="element.display_info_encerramento === null || element.display_info_encerramento" class="text-sm">
                  {{ 'tabela.info.encerramento' | message }} <span class="font-semibold">{{ element.display_info_encerramento === null ? '-' : element.display_info_encerramento }}</span>
                </p>
                <p *ngIf="element.fers_disponivel !== undefined" class="text-sm">
                  {{ 'tabela.info.fers' | message }} <span class="font-semibold">{{ element.fers_disponivel === null ? '-' : element.fers_disponivel }}</span>
                </p>
                <p *ngIf="element.bsw_disponivel !== undefined" class="text-sm">
                  {{ 'tabela.info.bsw' | message }} <span class="font-semibold">{{ element.bsw_disponivel === null ? '-' : element.bsw_disponivel }}</span>
                </p>
                <p *ngIf="element.cromatografia_disponivel !== undefined" class="text-sm">
                  {{ 'tabela.info.cromatografia' | message }} <span class="font-semibold">{{ element.cromatografia_disponivel === null ? '-' : element.cromatografia_disponivel }}</span>
                </p>
                <p *ngIf="element.densidade_disponivel !== undefined" class="text-sm">
                  {{ 'tabela.info.densidade' | message }} <span class="font-semibold">{{ element.densidade_disponivel === null ? '-' : element.densidade_disponivel }}</span>
                </p>
                <p *ngIf="element.instrumento_disponivel !== undefined" class="text-sm">
                  {{ 'tabela.info.instrumento' | message }} <span class="font-semibold">{{ element.instrumento_disponivel === null ? '-' : element.instrumento_disponivel }}</span>
                </p>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="'comentarios'">
          <th mat-header-cell *matHeaderCellDef class="bg-neutro-100 text-center text-base font-bold">
            {{ 'tabela.coluna.comentarios' | message }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="flex max-h-28 max-w-5xl items-center justify-center">
              <button
                *ngIf="hasColumnComentarios"
                [matMenuTriggerFor]="matMenuInfoDataComentarios"
                [title]="'tabela.coluna.comentarios' | message"
                type="button"
                [ngClass]="element.comentarios ? 'button-icon text-primario-700' : 'button-icon-disable'"
                [disabled]="!element.comentarios"
              >
                <span class="material-icons text-xl">message</span>
              </button>
              <mat-menu #matMenuInfoDataComentarios="matMenu" class="p-2">
                <div [innerHTML]="element.comentarios"></div>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="'fim'">
          <th mat-header-cell *matHeaderCellDef class="bg-neutro-100 text-lg"></th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container>

        <tr
          id="headerRow"
          [style.height]="isHeaderLarge ? '109px' : '56px'"
          class="sticky z-10"
          #headerRow
          mat-header-row
          *matHeaderRowDef="_headerOptionsAttributes; sticky: true"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: _headerOptionsAttributes"
          (click)="emitClickRow(row)"
          class="transition-all duration-150 hover:bg-slate-100"
        ></tr>

        <div class="mat-row flex items-center p-2">
          <td *matNoDataRow [colSpan]="headerOptions.length" class="mat-cell p-2">
            {{ 'tabela.sem.dados' | message }}
          </td>
        </div>
      </table>
    </ng-template>
  </div>

  <div class="w-full">
    <div *ngIf="subtitleFooter && !isLoading">
      <span>{{ subtitleFooter }}</span>
    </div>

    <div class="custom-paginator" *ngIf="!isPaginateDisable">
      <span class="pag-info">
        {{ 'tabela.paginacao.exibindo' | message }}
        {{ (paginaAtual * pageSize) + 1 }}
        {{ 'tabela.paginacao.ao' | message }}
        {{ (paginaAtual + 1) * pageSize > totalItems ? totalItems : (paginaAtual + 1) * pageSize }}
        {{ 'tabela.paginacao.de' | message }}
        {{ totalItems }}
        {{ 'tabela.paginacao.registros' | message }}
      </span>

      <div class="pag-buttons">
        <button class="pag-btn" (click)="goToFirstPage()" [disabled]="paginaAtual === 0" [title]="'tabela.paginacao.primeira' | message">
          <span class="material-icons">keyboard_double_arrow_left</span>
        </button>
        <button class="pag-btn" (click)="goToPage(paginaAtual)" [disabled]="paginaAtual === 0" [title]="'tabela.paginacao.anterior' | message">
          <span class="material-icons">chevron_left</span>
        </button>

        <ng-container *ngFor="let p of paginationNums">
          <button class="pag-btn" [class.active]="p === paginaAtual + 1" (click)="goToPage(p)">
            {{ p }}
          </button>
        </ng-container>

        <button class="pag-btn" (click)="goToPage(paginaAtual + 2)" [disabled]="paginaAtual >= totalPagesCalc - 1" [title]="'tabela.paginacao.proxima' | message">
          <span class="material-icons">chevron_right</span>
        </button>
        <button class="pag-btn" (click)="goToLastPage()" [disabled]="paginaAtual >= totalPagesCalc - 1" [title]="'tabela.paginacao.ultima' | message">
          <span class="material-icons">keyboard_double_arrow_right</span>
        </button>
      </div>

      <select
        class="pag-limit-select"
        (change)="onPageSizeChange(+$any($event.target).value)"
      >
        <option *ngFor="let opt of pageOptions" [value]="opt" [selected]="opt === pageSize">{{ opt }}</option>
      </select>
    </div>
  </div>
</div>
